// Custom Date picker

// Default
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Mui
import Box from "@mui/material/Box";

const CustomDatePicker = ({
  startDate,
  endDate,
  onChange,
}: {
  startDate: Date;
  endDate: Date;
  onChange: (dates: [Date, Date]) => void;
}) => {
  const dayClassName = (date: Date) => {
    if (startDate && endDate && date >= startDate && date <= endDate) {
      return "selected-range";
    }
    return "";
  };

  return (
    <Box mt={"16px"} mx={1}>
      <DatePicker
        selected={startDate}
        onChange={(dates) => onChange(dates as [Date, Date])}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        inline
        monthsShown={2}
        dayClassName={dayClassName}
      />
    </Box>
  );
};

export default CustomDatePicker;
